export default "__VITE_ASSET__DnXWur0t__"